import React from 'react'
import { Box, Skeleton } from '@mui/material'

const FlightCardShimmer = () => (
    <Box sx={{ mb: 2, p: 2, borderRadius: 2, border: '1px solid', borderColor: 'grey.200', bgcolor: 'white' }}>
        {/* Top row: logo, name, info icon */}
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Box display="flex" alignItems="center">
                <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1 }} />
                <Skeleton variant="text" width={80} height={20} />
            </Box>
            <Box mr={1}>
                <Skeleton variant="circular" width={20} height={20} />
            </Box>
        </Box>
        {/* Middle row: times and price */}
        <Box display="flex" alignItems="flex-start" justifyContent="space-between">
            <Box>
                <Skeleton variant="text" width={120} height={20} />
                <Box display="flex" alignItems="center" gap={0.5}>
                    <Skeleton variant="text" width={32} height={16} />
                    <Skeleton variant="text" width={12} height={16} />
                    <Skeleton variant="text" width={32} height={16} />
                </Box>
                <Skeleton variant="text" width={80} height={14} />
            </Box>
            <Box textAlign="right">
                <Skeleton variant="text" width={60} height={22} />
                <Box display="flex" justifyContent="center">
                    <Skeleton variant="text" width={40} height={18} sx={{ borderRadius: 0.5, mt: 0.5 }} />
                </Box>
            </Box>
        </Box>
    </Box>
)

export default FlightCardShimmer
